"use client";

import { c as _c } from "react/compiler-runtime";
import { type FC, type PropsWithChildren, Activity, useEffect, useState } from "react";
import posthog from "posthog-js";
import STYLES from "@vita-learning/styles";
import type { UserDetails } from "@vita-learning/types";
import { BottomNav, DrawerNav, SideNav } from "~/client/components/navigation";
import { UserStoreProvider } from "~/client/components/stores/UserStoreProvider";
import { useDevice, useWindowSize } from "~/client/hooks";
import { userToPostHogUser } from "~/shared/services/data/users";
import { toggleBool } from "~/shared/utils/toggleBool";
export interface AppProps {
  readonly user: UserDetails;
  readonly hasSideDrawer?: boolean;
}
export const App: FC<PropsWithChildren<AppProps>> = t0 => {
  const $ = _c(21);
  const {
    children,
    user,
    hasSideDrawer
  } = t0;
  const [isOpen, setIsOpen] = useState(false);
  const {
    width
  } = useWindowSize();
  const device = useDevice();
  let t1;
  if ($[0] !== user) {
    t1 = {
      data: user,
      isPending: false
    };
    $[0] = user;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const initialState = t1;
  const isMobile = width < STYLES.breakpoints.raw.laptops.small || device.type === "mobile" || device.type === "tablet";
  let t2;
  let t3;
  if ($[2] !== user) {
    t2 = () => {
      posthog.identify(user.id, userToPostHogUser(user));
    };
    t3 = [user];
    $[2] = user;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  useEffect(t2, t3);
  const t4 = !isMobile ? "visible" : "hidden";
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <SideNav />;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t4) {
    t6 = <Activity mode={t4}>{t5}</Activity>;
    $[6] = t4;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== children || $[9] !== initialState) {
    t7 = <UserStoreProvider initialState={initialState}>{children}</UserStoreProvider>;
    $[8] = children;
    $[9] = initialState;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  const t8 = isMobile ? "visible" : "hidden";
  let t9;
  if ($[11] !== hasSideDrawer || $[12] !== isOpen) {
    t9 = hasSideDrawer ? <><BottomNav onToggleMenu={() => setIsOpen(toggleBool)} hasSideDrawer={true} /><DrawerNav isOpen={isOpen} setIsOpen={setIsOpen} /></> : <BottomNav onToggleMenu={() => setIsOpen(toggleBool)} />;
    $[11] = hasSideDrawer;
    $[12] = isOpen;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== t8 || $[15] !== t9) {
    t10 = <Activity mode={t8}>{t9}</Activity>;
    $[14] = t8;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t10 || $[18] !== t6 || $[19] !== t7) {
    t11 = <>{t6}{t7}{t10}</>;
    $[17] = t10;
    $[18] = t6;
    $[19] = t7;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  return t11;
};